export default "__VITE_ASSET__XfsSmzLR__"